import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import axios from 'axios';
import LoadingOverlay from '../components/LoadingOverlay';

const initialFormData = { origenEnvioId: 0, descripcion: '' };

const OrigenEnvio = () => {
    const toast    = useRef(null);
    const HOST_API = process.env.REACT_APP_URL;

    const [formData, setFormData] = useState(initialFormData);
    const [visible,  setVisible]  = useState(false);
    const [loading,  setLoading]  = useState(false);
    const [origenes, setOrigenes] = useState([]);

    const fetchOrigenes = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await axios.get(`${HOST_API}api/origenenvio/GetOrigenesEnvio`);
            setOrigenes(data);
        } catch {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar los orígenes de envío', life: 3000 });
        } finally {
            setLoading(false);
        }
    }, [HOST_API]);

    useEffect(() => { fetchOrigenes(); }, [fetchOrigenes]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.descripcion.trim()) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'La descripción es obligatoria', life: 3000 });
            return;
        }
        try {
            await axios.post(`${HOST_API}api/origenenvio/SaveOrigenEnvio`, formData);
            setVisible(false);
            fetchOrigenes();
            toast.current.show({ severity: 'success', summary: formData.origenEnvioId ? 'Actualizado' : 'Creado', detail: 'Origen de envío guardado correctamente', life: 2500 });
        } catch {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar', life: 3000 });
        }
    };

    const handleEdit   = (row) => { setFormData({ origenEnvioId: row.origenEnvioId, descripcion: row.descripcion || '' }); setVisible(true); };

    const handleDelete = (id, descripcion) => {
        confirmDialog({
            message: `¿Estás seguro de eliminar "${descripcion}"?`,
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/origenenvio/DeleteOrigenEnvio?origenEnvioId=${id}`);
                    fetchOrigenes();
                    toast.current.show({ severity: 'success', summary: 'Eliminado', detail: 'Origen de envío eliminado', life: 2500 });
                } catch {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar', life: 3000 });
                }
            },
        });
    };

    return (
        <>
            <h4>Origen de Envío</h4>
            <br />
            <ConfirmDialog />
            <Toast ref={toast} />
            <LoadingOverlay visible={loading} />
            <div className="flex align-items-center gap-3 mb-3">
                <Button label="Nuevo Origen" icon="pi pi-plus" onClick={() => { setFormData(initialFormData); setVisible(true); }} />
            </div>
            <Dialog
                header={formData.origenEnvioId ? 'Editar Origen de Envío' : 'Nuevo Origen de Envío'}
                visible={visible}
                style={{ width: '440px' }}
                breakpoints={{ '960px': '100vw' }}
                modal
                onHide={() => setVisible(false)}
            >
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-column gap-3 mt-2">
                        <div>
                            <label style={labelStyle}>Descripción <span style={{ color: '#f04438' }}>*</span></label>
                            <InputText value={formData.descripcion} onChange={(e) => setFormData(p => ({ ...p, descripcion: e.target.value }))} className="p-inputtext-sm w-full" placeholder="Ej: MercadoLibre" maxLength={200} autoFocus />
                        </div>
                        <div className="flex justify-content-end gap-2 mt-2">
                            <Button label="Cancelar" type="button" severity="secondary" text onClick={() => setVisible(false)} />
                            <Button label="Guardar" icon="pi pi-save" type="submit" />
                        </div>
                    </div>
                </form>
            </Dialog>
            <div className="grid">
                <div className="col-12">
                    <DataTable value={origenes} paginator rows={10} rowsPerPageOptions={[5, 10, 25]} showGridlines responsiveLayout="scroll" emptyMessage="No hay orígenes de envío" className="p-datatable-gridlines bg-white" sortField="descripcion" sortOrder={1}>
                        <Column field="origenEnvioId" header="ID"          sortable style={{ width: '5rem' }} />
                        <Column field="descripcion"   header="Descripción" sortable style={{ fontWeight: 500 }} />
                        <Column header="Acciones" style={{ width: '8rem' }} body={(row) => (
                            <div className="flex gap-2 justify-content-center">
                                <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEdit(row)} tooltip="Editar" />
                                <Button icon="pi pi-trash"  rounded className="btn-delete"  onClick={() => handleDelete(row.origenEnvioId, row.descripcion)} tooltip="Eliminar" />
                            </div>
                        )} />
                    </DataTable>
                </div>
            </div>
        </>
    );
};

const labelStyle = { display: 'block', marginBottom: '0.35rem', fontWeight: 500, color: '#344054', fontSize: '0.87rem' };

export default OrigenEnvio;
